import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactMarkdown from "react-markdown";
import { toast } from "react-toastify";   //  Correct import
import "react-toastify/dist/ReactToastify.css";
import useReduxStore from "../../hooks/useReduxStore";
import { CHATAI } from "../../repository/auth";

const ChatAi = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { selector: user } = useReduxStore("auth");


    const { selector: PatientData } = useReduxStore("PatientData");
    // const [messages, setMessages] = useState([
    //     { sender: "ai", text: "👋 Hi there! I’m your Dental Assistant. How can I help you today?" },
    //     !PatientData?.id
    //         ? { sender: "ai", text: "Please select a patient to refine your search. Otherwise, you may continue with a general query." }
    //         : null
    // ].filter(Boolean));

    const [messages, setMessages] = useState([
        { sender: "ai", text: "👋 Hi there! I’m your Dental Assistant. How can I help you today?" },
    ]);

    useEffect(() => {
        if (!PatientData?.id) {
            // Add patient message if missing
            setMessages(prev => {
                const exists = prev.some(m => m.text.includes("Please select a patient to refine your search. Otherwise, you may continue with a general query."));
                if (!exists) {
                    return [
                        ...prev,
                        { sender: "ai", text: "Please select a patient to refine your search. Otherwise, you may continue with a general query." }
                    ];
                }
                return prev;
            });
        } else {
            // Remove patient message if patient *is selected*
            setMessages(prev =>
                prev.filter(m => !m.text.includes("Please select a patient to refine your search. Otherwise, you may continue with a general query."))
            );
        }
    }, [PatientData?.id]);

    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [hasMoved, setHasMoved] = useState(false); // ** Track if button actually moved during drag **
    const buttonRef = useRef(null);
    const chatBodyRef = useRef(null);

    useEffect(() => {

    }, [PatientData]);

    const buildAiText = (text, hasMore) => {
        if (!hasMore) return text;
        return `${text}\n\n**[Show more](show-more)**`;
    };


    // Scroll to bottom
    useEffect(() => {
        if (isOpen && chatBodyRef.current) {
            setTimeout(() => {
                chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
            }, 50);
        }
    }, [isOpen, messages]);

    useEffect(() => {
        const updatePosition = () => {
            setPosition({
                x: window.innerWidth - 180, // 180px from right edge
                y: window.innerHeight - 80   // 80px from bottom edge
            });
        };

        updatePosition();
        window.addEventListener('resize', updatePosition);
        return () => window.removeEventListener('resize', updatePosition);
    }, []);

    // ** DRAGGABLE FUNCTIONALITY - Handle mouse down to start dragging **
    const handleMouseDown = (e) => {
        if (isOpen) return; // Don't allow dragging when chat is open

        setIsDragging(true);
        setHasMoved(false); // ** Reset moved flag when starting drag **
        setDragOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
    };

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!isDragging) return;

            // ** Mark that the button has moved **
            setHasMoved(true);

            const newX = e.clientX - dragOffset.x;
            const newY = e.clientY - dragOffset.y;

            // ** Constrain position within viewport **
            const maxX = window.innerWidth - (buttonRef.current?.offsetWidth || 150);
            const maxY = window.innerHeight - (buttonRef.current?.offsetHeight || 60);

            setPosition({
                x: Math.max(0, Math.min(newX, maxX)),
                y: Math.max(0, Math.min(newY, maxY))
            });
        };

        const handleMouseUp = () => {
            setIsDragging(false);
        };

        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, dragOffset]);

    const [hasMore, setHasMore] = useState(false);
    const [nextCursor, setNextCursor] = useState(null);
    const [lastQuestion, setLastQuestion] = useState("");


    // -------------------------
    //  Send Message
    // -------------------------
    // const handleSend = async () => {
    //     if (!input.trim()) return;

    //     // Add user message
    //     setMessages((prev) => [...prev, { sender: "user", text: input }]);
    //     setInput("");
    //     setLoading(true);

    //     try {
    //         const payload = {
    //             clinicId: user?.clinic_id,
    //             providerId: user?.user_id || null,
    //             patientId: PatientData?.id || null,
    //             timezone: user?.timezone || "Asia/Kolkata",
    //             question: input,
    //             locationId: user?.location_id,
    //             cursor: hasMore && messages?.nextCursor || null
    //         };
    //         const response = await CHATAI(payload);
    //         console.log(response, "111111111");

    //         const aiReply = response?.data ||
    //             "⚠️ Sorry, I couldn’t process your request.";
    //         setMessages((prev) => [...prev, { sender: "ai", text: aiReply }]);

    //         setHasMore(response?.data?.hasMore === true);
    //         setNextCursor(response?.data?.nextCursor || null);
    //     } catch (err) {
    //         //  FIXED: Working toast.error message
    //         toast.error(
    //             err?.message ||
    //             "Network error: Unable to connect to AI service"
    //         );
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleSend = async () => {
        if (!input.trim()) return;

        setLastQuestion(input);
        setMessages(prev => [...prev, { sender: "user", text: input }]);
        setInput("");
        setLoading(true);

        try {
            const payload = {
                clinicId: user?.clinic_id,
                providerId: user?.user_id || null,
                patientId: PatientData?.id || null,
                timezone: user?.timezone || "Asia/Kolkata",
                question: input,
                locationId: user?.location_id,
                cursor: null
            };

            const response = await CHATAI(payload);
            const aiText =
                typeof response?.data?.text === "string"
                    ? buildAiText(response.data.text, response?.data?.hasMore)
                    : "⚠️ Sorry, I couldn’t process your request.";

            setMessages(prev => [...prev, { sender: "ai", text: aiText }]);

            setHasMore(response?.data?.hasMore === true);
            setNextCursor(response?.data?.nextCursor || null);

        } catch (err) {
            toast.error(err?.message || "Network error");
        } finally {
            setLoading(false);
        }
    };

    // -------------------------
    // Load More (Anchor Click)
    // -------------------------
    const handleSendNew = async () => {
        if (!nextCursor || !lastQuestion) return;

        setLoading(true);

        try {
            const payload = {
                clinicId: user?.clinic_id,
                providerId: user?.user_id || null,
                patientId: PatientData?.id || null,
                timezone: user?.timezone || "Asia/Kolkata",
                question: lastQuestion,
                locationId: user?.location_id,
                cursor: nextCursor
            };

            const response = await CHATAI(payload);

            const aiText =
                typeof response?.data?.text === "string"
                    ? buildAiText(response.data.text, response?.data?.hasMore)
                    : "⚠️ Sorry, I couldn’t process your request.";

            setMessages(prev => [...prev, { sender: "ai", text: aiText }]);

            setHasMore(response?.data?.hasMore === true);
            setNextCursor(response?.data?.nextCursor || null);

        } catch (err) {
            toast.error(err?.message || "Network error");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="chat-ai-wrapper">
            {/* Collapsed Button */}
            {!isOpen ? (
                <div ref={buttonRef} className="chat-collapsed" onClick={() => !hasMoved && setIsOpen(true)} onMouseDown={handleMouseDown} style={{
                    position: 'fixed',
                    left: `${position.x}px`,
                    top: `${position.y}px`,
                    cursor: isDragging ? 'grabbing' : 'grab',
                    userSelect: 'none',
                    zIndex: 9999
                }}>
                    <button className="assist-btn">
                        <span className="assist-icon">✨</span>
                        <span className="assist-text">Chat</span>
                    </button>
                </div>
            ) : (
                <div className="chat-expanded shadow">

                    {/* Header */}
                    <div className="chat-header bg-dark text-light">
                        <strong>Dental AI Assistant</strong>
                        <Button
                            variant="outline-light"
                            size="sm"
                            onClick={() => setIsOpen(false)}
                        >
                            ✕
                        </Button>
                    </div>

                    {/* Chat Messages */}

                    <div className="chat-body" ref={chatBodyRef}>
                        {messages.map((msg, index) => (
                            <div
                                key={index}
                                className={`message-ai ${msg.sender === "user" ? "user-msg" : "ai-msg"}`}
                            >
                                {msg.sender === "ai" ? (
                                    <ReactMarkdown
                                        components={{
                                            a: ({ href, children }) => {
                                                if (href === "show-more") {
                                                    return (
                                                        <a
                                                          className="ai_Show_more"
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleSendNew();
                                                            }}
                                                        >
                                                            {children}
                                                        </a>
                                                    );
                                                }

                                                return (
                                                    <a
                                                        href={href}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: "#00cc66" }}
                                                    >
                                                        {children}
                                                    </a>
                                                );
                                            }
                                        }}
                                    >
                                        {msg.text}
                                    </ReactMarkdown>
                                ) : (
                                    <div>{msg.text}</div>
                                )}
                            </div>
                        ))}

                        {loading && (
                            <div className="message-ai ai-msg">
                                <Spinner animation="border" size="sm" />
                                <span className="ms-2">Thinking...</span>
                            </div>
                        )}
                    </div>
                    {/* <div className="chat-body" ref={chatBodyRef}>
                        {messages.map((msg, index) => (
                            <div
                                key={index}
                                className={`message-ai ${msg.sender === "user" ? "user-msg" : "ai-msg"}`}
                            >
                                {msg.sender === "ai" ? (
                                    <ReactMarkdown
                                        components={{
                                            a: ({ node, ...props }) => (
                                                <a
                                                    {...props}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "#00cc66" }}
                                                />
                                            ),
                                        }}
                                    >
                                        {msg.text}
                                    </ReactMarkdown>
                                ) : (
                                    <div>{msg.text}</div>
                                )}
                            </div>
                        ))}

                        {loading && (
                            <div className="message-ai ai-msg">
                                <Spinner animation="border" size="sm" />{" "}
                                <span className="ms-2">Thinking...</span>
                            </div>
                        )}

                    
                        {hasMore && !loading && (
                            <div className="text-center mt-2">
                                <Button
                                    size="sm"
                                    variant="outline-success"
                                    onClick={handleSendNew}
                                >
                                    Show more
                                </Button>
                            </div>
                        )}
                    </div> */}

                    {/* Input Box */}
                    <div className="chat-input d-flex align-items-center">
                        <Form.Control
                            type="text"
                            placeholder="Type your message..."
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleSend()}
                        />
                        <Button variant="success" className="send-btn" onClick={handleSend}>
                            ➤
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatAi;
